import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-b border-crema bg-crema/60" data-id="element-109" data-mp="2lu4o5ip4lm78">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-110" data-mp="30isg7ezrjdsf">
        <SectionHeader id="problema" eyebrow="¿Te suena familiar?" title="Querés cambiar cosas de tu vida, pero no sabés por dónde empezar." description="Si sentís que necesitás ordenar tu vida, recuperar el control o volver a avanzar, probablemente conozcas alguna de estas situaciones:" data-id="element-111" data-mp="2vpzc8tc4c9he" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-112" data-mp="3jfjwdfk0dcs9">
          {problems.map(({
          icon: Icon,
          title,
          desc
        }) => <li key={title} className="flex gap-2.5 rounded-xl border border-l-4 border-crema border-l-terracota bg-blanco p-3" data-id="element-113" data-mp="3eew6wybfh405">
              <Icon size={18} aria-hidden="true" className="mt-0.5 flex-shrink-0 text-terracota" data-id="element-114" data-mp="1k49b7nwd8u8k" />
              <div data-id="element-115" data-mp="jeepei9tj9fw">
                <h3 className="text-sm font-extrabold text-azul" data-id="element-116" data-mp="jey7q03drzug">{title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-azul/80 sm:text-sm" data-id="element-117" data-mp="oczrkn8ms36z">{desc}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}